var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-panel"},[_c('header',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('hr')]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }